import type { Request } from '../../../codegen/graphql';
import type { QuickActionVerb } from '../pricing-batch-actions-cell/useApplyQuickAction';
import type { PriceChangeRequestMetadata } from '../../../types/price-change-request';

export function queuedRequestLabel(
    request: Pick<Request, 'friendlyId' | 'productSku'>,
): string {
    const sku = request.productSku?.trim();
    if (sku && request.friendlyId != null) {
        return `#${request.friendlyId} · ${sku}`;
    }
    return (
        sku ||
        (request.friendlyId != null ? `#${request.friendlyId}` : 'Request')
    );
}

export type QueuedPriceChangeQuickAction = {
    readonly requestId: string;
    readonly requestLabel: string;
    readonly verb: QuickActionVerb;
    readonly outcome: string;
    readonly notes: string;
    readonly metadata: PriceChangeRequestMetadata;
};
